const offersConfiguration = [
    // 20% discount with voucher codew
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/avira-prime?x-a-source=cw',
    //     eshopUrl: 'https://e-shop.avira.com/checkout?product=1955&language={language}&x-subscription-type=annual&runtime=12&users=1&x-a-source=cw',
    //     discount: '<span>20%</span>',
    //     voucher: 'Prime19-BF',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         discountDesc: 'cw.prime_offer.discount_desc',
    //         learnMore: 'cw.prime_offer.btn_learn_more',
    //         button: 'cw.prime_offer.btn_get_prime',
    //     },
    // },
    // {
    //     product: 'Internet Security Suite',
    //     productId: 'isec0',
    //     learnMoreUrl: 'https://www.avira.com/{language}/avira-internet-security-suite?x-a-source=cw',
    //     eshopUrl: 'https://e-shop.avira.com/checkout?product=1905&language={language}&x-subscription-type=annual&runtime=12&users=1&x-a-source=cw',
    //     discount: '<span>20%</span>',
    //     voucher: 'Isec19-BF',
    //     bundleIds: ['aps10', 'aps20', 'isec0'],
    //     translationKeys: {
    //         discountDesc: 'cw.isec_offer.discount_desc',
    //         learnMore: 'cw.isec_offer.btn_learn_more',
    //         button: 'cw.isec_offer.btn_get_isec',
    //     },
    // },

    // New Year, 35% discount without voucher code
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime-new-year-2019?x-a-source=cw',
    //     eshopUrl: 'https://e-shop.avira.com/checkout?1&promotion=cw-banner-prm-35-ny&language={language}&product=1&x-a-source=cw&x-a-medium=cw-ny-banner',
    //     discount: '<span>35%</span>',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         learnMore: 'cw.prime_offer.btn_learn_more',
    //         button: 'cw.prime_offer.btn_get_prime',
    //     },
    // },

    // 20% discount without voucher code Last one live
    {
        product: 'Avira Prime',
        productId: 'aps10',
        learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
        bundleIds: ['aps10', 'aps20'],
        translationKeys: {
            discountDesc: 'cw.banner.generic_desc_1',
            learnMore: 'cw.prime_offer.btn_learn_more',
            button: 'cw.general.upgrade',
        },
    },
    {
        product: 'Internet Security',
        productId: 'isec0',
        learnMoreUrl: 'https://www.avira.com/{language}/internet-security-suite?x-a-source=cw',
        bundleIds: ['aps10', 'aps20', 'isec0'],
        translationKeys: {
            discountDesc: 'cw.banner.generic_desc_1',
            learnMore: 'cw.isec_offer.btn_learn_more',
            button: 'cw.general.upgrade',
        },
    },

    // Black friday 2019
    // {
    //     product: 'Avira Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     discount: '<span>50%</span>',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.banner.cyber_week_2019_title',
    //         discountDesc: 'cw.banner.cyber_week_2019_prime_desc',
    //         learnMore: 'cw.banner.explore_product',
    //         button: 'cw.banner.get_deal_prime',
    //     },
    // },
    // {
    //     product: 'Internet Security Suite',
    //     productId: 'isec0',
    //     learnMoreUrl: 'https://www.avira.com/{language}/internet-security-suite?x-a-source=cw',
    //     discount: '<span>50%</span>',
    //     bundleIds: ['aps10', 'aps20', 'isec0'],
    //     translationKeys: {
    //         title: 'cw.banner.cyber_week_2019_title',
    //         discountDesc: 'cw.banner.cyber_week_2019_isec_desc',
    //         learnMore: 'cw.banner.explore_product',
    //         button: 'cw.banner.get_deal_isec',
    //     },
    // },

    // winter campaign
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/201902-winter-prime-promo?x-a-source=cw',
    //     eshopUrl: 'https://e-shop.avira.com/checkout?1&promotion=cw-banner-prm-35-win&product=1&language={language}&runtime=12&users=1&x-a-source=cw',
    //     discount: '<span>35%</span>',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         learnMore: 'cw.prime_offer.btn_learn_more',
    //         button: 'cw.prime_offer.btn_get_prime',
    //     },
    // },

    // Spring Campaign 2021
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.offer.spring_campaign_description',
    //         button: 'cw.offer.upgrade_and_save',
    //     },
    // },

    // Summer Campaign 2021
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.offer.campaign_description',
    //         button: 'cw.offer.banner_button',
    //     },
    // },
    // {
    //     product: 'Antivirus Pro',
    //     productId: 'aapd5',
    //     learnMoreUrl: 'https://www.avira.com/{language}/free-antivirus?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20', 'isec0', 'aapd5'],
    //     translationKeys: {
    //         title: 'cw.offer.campaign_description',
    //         button: 'cw.offer.banner_button',
    //     },
    // },

    // End of year campaign
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.offer.winter_campaign_description',
    //         button: 'cw.offer.banner_button',
    //     },
    // },
    // {
    //     product: 'Antivirus Pro',
    //     productId: 'aapd5',
    //     learnMoreUrl: 'https://www.avira.com/{language}/free-antivirus?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20', 'isec0', 'aapd5'],
    //     translationKeys: {
    //         title: 'cw.offer2.campaign_description',
    //         button: 'cw.offer.banner_button',
    //     },
    // },
    // {
    //     product: 'Prime 25',
    //     productId: 'aps20',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps20'],
    //     translationKeys: {
    //         title: 'cw.banner.prime_25.title',
    //         button: 'cw.offer.banner_button',
    //     },
    // },

    // End of Summer Campaign 2021
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.offer.campaign_description',
    //         button: 'cw.offer.banner_button',
    //     },
    // },
    // {
    //     product: 'Antivirus Pro',
    //     productId: 'aapd5',
    //     learnMoreUrl: 'https://www.avira.com/{language}/free-antivirus?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20', 'isec0', 'aapd5'],
    //     translationKeys: {
    //         title: 'cw.offer.campaign_description',
    //         button: 'cw.offer.banner_button',
    //     },
    // },

    // Black friday 2021
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.offer4.campaign_description_aps10',
    //         button: 'cw.offer4.button_aps10',
    //     },
    // },
    // {
    //     product: 'Prime 25',
    //     productId: 'aps20',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps20'],
    //     translationKeys: {
    //         title: 'cw.offer4.campaign_description_aps20',
    //         button: 'cw.offer4.button_aps20',
    //     },
    // },
    // Cyber week 2021
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.offer4.campaign_description_aps10',
    //         button: 'cw.offer4.button_aps10',
    //     },
    // },
    // {
    //     product: 'Prime 25',
    //     productId: 'aps20',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps20'],
    //     translationKeys: {
    //         title: 'cw.offer4.campaign_description_aps20',
    //         button: 'cw.offer4.button_aps20',
    //     },
    // },
    // Cyber week 2021
    // {
    //     product: 'Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         title: 'cw.offer4.campaign_description_aps10',
    //         button: 'cw.offer4.button_aps10',
    //     },
    // },
    // {
    //     product: 'Prime 25',
    //     productId: 'aps20',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps20'],
    //     translationKeys: {
    //         title: 'cw.offer4.campaign_description_aps20',
    //         button: 'cw.offer4.button_aps20',
    //     },
    // },

    // OE-7378 - 97% off for AV
    // {
    //     product: 'Avira Prime',
    //     productId: 'aps10',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20'],
    //     translationKeys: {
    //         discountDesc: 'cw.banner.generic_desc_1',
    //         learnMore: 'cw.prime_offer.btn_learn_more',
    //         button: 'cw.general.upgrade',
    //     },
    // },
    // {
    //     product: 'Antivirus Pro',
    //     productId: 'aapd5',
    //     learnMoreUrl: 'https://www.avira.com/{language}/free-antivirus?x-a-source=cw',
    //     bundleIds: ['aps10', 'aps20', 'isec0', 'aapd5'],
    //     translationKeys: {
    //         title: 'cw.offer4.campaign_description',
    //         button: 'cw.offer4.campaign_cta',
    //     },
    // },
    // {
    //     product: 'Prime 25',
    //     productId: 'aps20',
    //     learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    //     bundleIds: ['aps20'],
    //     translationKeys: {
    //         title: 'cw.banner.prime_25.title',
    //         button: 'cw.offer.banner_button',
    //     },
    // },

];

export default offersConfiguration;



// WEBPACK FOOTER //
// ./scripts/abtesting/data.js